class LoginModal {
  constructor(element, open = false) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.close = element.querySelector('.modal__close');
    this.content = element.querySelector('.modal__container');
    this.overlay = element.querySelector('.modal__overlay');

    if (open) {
      MicroModal.show(this.element.id);
    }

    if (window.location.hash === `#${element.id}`) {
      MicroModal.show(this.element.id);
    }

    window.addEventListener('logout.open', () => {
      MicroModal.show(this.element.id);
    });

    window.addEventListener('logout.closed', () => {
      MicroModal.close(this.element.id);
    });

    this.init();
  }

  init() {
    this.initBackdrop();
    if (this.close) {
      this.close.addEventListener('click', this.closeModal.bind(this));
    }
    // get account modal toggles
    (document.querySelectorAll('.logout-modal-toggle') ?? []).forEach((el) => {
      el.addEventListener('click', () => {
        MicroModal.show(this.element.id);
      });
    });
  }

  initBackdrop() {
    if (this.content) {
      this.content.addEventListener('click', (ev) => {
        ev.stopImmediatePropagation();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (ev) => {
        this.closeModal();
      });
    }
  }

  closeModal() {
    MicroModal.close(this.element.id);
  }
}

export default LoginModal;
